import { useState } from "react";
import PropTypes from "prop-types";
import { Radio, RadioGroup } from "@components/Radio";
import { Button } from "@components/Button";
import { formatSize } from "@lib/formatString";
import styles from "./styles/selector.module.css";

export function Selector({ heading, data, name, updateVariant, openSizeGuide }) {
  const [titleOnHover, setTitleOnHover] = useState(null);
  const selected = data?.find((datum) => datum.selected);

  const onMouseEnter = (event) => {
    const value = event.target.getAttribute("data-label");
    setTitleOnHover(value);
  };

  const onMouseLeave = (event) => {
    setTitleOnHover(null);
  };

  const onClick = (selectedValue) => {
    if (updateVariant) {
      updateVariant(selectedValue);
    }
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h4>
          <span>{heading} </span>
          {titleOnHover ? formatSize(titleOnHover) : formatSize(selected?.labelText)}
        </h4>
      </header>

      <RadioGroup onClickRadioButton={onClick} selectedValue={selected?.value} name={name}>
        {data.map((datum) => (
          <Radio {...datum} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} />
        ))}
      </RadioGroup>
      {openSizeGuide && (
        <footer className={styles.footer}>
          <Button
            variant="tertiary"
            handleClick={openSizeGuide}
            description="Size Guide"
            descriptionText="Click to open Size Guide"
          >
            Not sure? Check the size guide.
          </Button>
        </footer>
      )}
    </div>
  );
}

Selector.propTypes = {
  /** the heading of the swatch used as the title */
  heading: PropTypes.string.isRequired,
  /**
   * The name of the swatch uses for that radio group
   */
  name: PropTypes.string.isRequired,
  /** Data used to construct the radio buttons values with */
  data: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      labelText: PropTypes.string,
      fill: PropTypes.string,
    }).isRequired
  ).isRequired,
};
